import { COLORS } from 'constants/index';

const MuiDivider = {
  root: {
    backgroundColor: COLORS.GRAY_08,
  },
  inset: {
    marginLeft: '64px',
  },
};

export default MuiDivider;
